import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Arka plan resmini import ediyoruz
import hakkımızdaHeroImg from '../assets/hakkımızda-hero-img.webp'; 
import hakkımızdatwoimg from '../assets/hakkımızda-img.webp';

function Hakkimizda() {
  // AOS ANİMASYONLARINI BAŞLAT
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
    });
  }, []);

  // --- GOOGLE İÇİN KURUMSAL SEO ŞEMASI (JSON-LD) ---
  const aboutSchemaData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "description": "Ankara'da 15 yılı aşkın tecrübesiyle garantili beyaz eşya, kombi ve klima tamir servisi. Uzman kadro ve %100 orijinal yedek parça garantisi.",
      "telephone": "+903125810881",
      "areaServed": "Ankara",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Ankara",
        "addressCountry": "TR"
      }
    }
  };

  return (
    <div className="about-page-wrapper">
      
      <Helmet>
        <title>Kurumsal | Ankara Merkez Teknik Servis</title>
        <meta name="description" content="Ankara'da 15 yılı aşkın süredir garantili beyaz eşya, kombi ve klima tamir hizmeti sunan teknolojik ve güvenilir servis ağımızla tanışın." />
        <script type="application/ld+json">
          {JSON.stringify(aboutSchemaData)}
        </script>
      </Helmet>

      {/* --- CİNEMATİC HERO (ARKA PLAN RESİMLİ) --- */}
      <section 
        className="about-cinematic-hero" 
        data-aos="fade-in"
        style={{
          backgroundImage: `url(${hakkımızdaHeroImg})`, // Arka plan resmi burada basılıyor
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed' // Hafif parallax efekti verir (isteğe bağlı, silebilirsin)
        }}
      >
        {/* Yazıların okunması için koyu katman */}
        <div className="cinematic-overlay"></div> 
        
        <div className="cinematic-content" data-aos="zoom-in" data-aos-delay="200">
          <span className="sub-title-elegant">BİZ KİMİZ?</span>
          <h1>Ankara'nın En Köklü<br/>Teknik Servis Çözüm Ortağı</h1>
          <p>
            15 yılı aşkın tecrübemiz, uzman mühendis kadromuz ve %100 orijinal parça 
            garantimizle, cihazlarınıza ilk günkü ömrünü geri kazandırıyoruz.
          </p>
        </div>
      </section>

      {/* --- YÜZEN GÜVEN ŞERİDİ (TRUST BAR) --- */}
      <div className="trust-bar-wrapper" data-aos="fade-up" data-aos-delay="400">
        {/* ... (Burası aynı kalıyor, değiştirmedim) ... */}
        <div className="trust-bar-container">
          <div className="trust-item">
            <span className="t-icon">🏆</span>
            <div className="t-text"><strong>15+ Yıl</strong><span>Sektörel Tecrübe</span></div>
          </div>
          <div className="trust-item divider"></div>
          <div className="trust-item">
            <span className="t-icon">🛡️</span>
            <div className="t-text"><strong>1 Yıl Garanti</strong><span>İşçilik ve Parça</span></div>
          </div>
          <div className="trust-item divider"></div>
          <div className="trust-item">
            <span className="t-icon">⏱️</span>
            <div className="t-text"><strong>7/24 Destek</strong><span>Aynı Gün Servis</span></div>
          </div>
          <div className="trust-item divider"></div>
          <div className="trust-item">
            <span className="t-icon">📍</span>
            <div className="t-text"><strong>Geniş Ağ</strong><span>Tüm Ankara İlçeleri</span></div>
          </div>
        </div>
      </div>

      {/* --- HİKAYEMİZ & VİZYON --- */}
      <section className="about-story-section">
        {/* ... (Burası aynı kalıyor, değiştirmedim) ... */}
        <div className="story-container">
          <div className="story-left" data-aos="fade-right">
            <h2>Klasik Bir Tamirciden Çok Daha Fazlası.</h2>
            <div className="story-text">
              <p>Ankara Merkez Teknik olarak yola çıkarken tek bir hedefimiz vardı: Geleneksel tamir süreçlerini dijitalleştirmek ve şeffaflaştırmak.</p>
              <p>Bugün; uzman kadromuz ve %100 orijinal yedek parça ağımızla Ankara'nın en güvenilir teknik servis laboratuvarı konumundayız.</p>
            </div>
            <div className="story-stats">
              <div className="s-stat" data-aos="zoom-in" data-aos-delay="100"><strong>15+</strong><span>Yıllık Tecrübe</span></div>
              <div className="s-stat" data-aos="zoom-in" data-aos-delay="200"><strong>%100</strong><span>Şeffaf Fiyat</span></div>
              <div className="s-stat" data-aos="zoom-in" data-aos-delay="300"><strong>1 Yıl</strong><span>Garanti</span></div>
            </div>
          </div>
          <div className="story-right" data-aos="fade-left">
            <div className="story-image-wrapper">
              <div className="story-bg-shape"></div>
              <img src={hakkımızdatwoimg} alt="Ankara Teknik Servis Laboratuvarı" className="story-img" />
              <div className="story-floating-card" data-aos="fade-up" data-aos-delay="500">
                <div className="f-icon">⭐</div>
                <div className="f-text"><strong>4.9 / 5.0</strong><span>Müşteri Memnuniyeti</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="orange-divider"></div>
      
      {/* --- NEDEN BİZ? --- */}
      <section className="why-us-cyber-section">
        {/* ... (Burası aynı kalıyor, değiştirmedim) ... */}
        <div className="why-us-container">
          <div className="section-heading-dark" data-aos="fade-down">
            <span className="sub-tag-neon">FARKIMIZ</span>
            <h3>Neden Ankara Merkez Teknik?</h3>
          </div>
          <div className="cyber-cards-grid">
            <div className="cyber-feature-card" data-aos="fade-up" data-aos-delay="100"><div className="cyber-icon">🛡️</div><h4>1 Yıl Garanti</h4><p>Yaptığımız tüm onarımlar güvencemiz altındadır.</p></div>
            <div className="cyber-feature-card" data-aos="fade-up" data-aos-delay="200"><div className="cyber-icon">⚡</div><h4>Aynı Gün Müdahale</h4><p>Gezici servis ağımızla anında kapınızdayız.</p></div>
            <div className="cyber-feature-card" data-aos="fade-up" data-aos-delay="300"><div className="cyber-icon">👨‍🔧</div><h4>Sertifikalı Uzmanlar</h4><p>Ekibimiz teknik beyin kartlarına hakim ustalardan oluşur.</p></div>
            <div className="cyber-feature-card" data-aos="fade-up" data-aos-delay="400"><div className="cyber-icon">💳</div><h4>Şeffaf Fiyat</h4><p>Sürpriz maliyet yok, net ücreti önceden sunarız.</p></div>
          </div>
          <div className="why-us-action" data-aos="zoom-in"><Link to="/iletisim" className="btn-primary">Hemen Arıza Kaydı Oluştur</Link></div>
        </div>
      </section>

    </div>
  );
}

export default Hakkimizda;